import moment from 'moment'
import 'moment/locale/es' // Importa el locale que deseas utilizar
moment.locale('es') // Establece el locale a español ('es')

export default moment
